'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZOOM_STEP = 0.2;
var MIN_ZOOM = 0.1;
var MAX_ZOOM = 5;

var applyConstraints = function applyConstraints() {
  var zoom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return parseFloat(Math.min(Math.max(zoom, MIN_ZOOM), MAX_ZOOM).toFixed(2));
};

function withZoom(Component) {
  var WithZoomChart = function (_React$Component) {
    _inherits(WithZoomChart, _React$Component);

    function WithZoomChart(props) {
      _classCallCheck(this, WithZoomChart);

      var _this = _possibleConstructorReturn(this, (WithZoomChart.__proto__ || Object.getPrototypeOf(WithZoomChart)).call(this, props));

      _this.state = {
        zoom: 1
      };

      _this.onZoomIn = _this.onZoomIn.bind(_this);
      _this.onZoomOut = _this.onZoomOut.bind(_this);
      _this.onResetZoom = _this.onResetZoom.bind(_this);
      return _this;
    }

    _createClass(WithZoomChart, [{
      key: 'onZoomIn',
      value: function onZoomIn() {
        this.setState({ zoom: applyConstraints(this.state.zoom + ZOOM_STEP) });
      }
    }, {
      key: 'onZoomOut',
      value: function onZoomOut() {
        this.setState({ zoom: applyConstraints(this.state.zoom - ZOOM_STEP) });
      }
    }, {
      key: 'onResetZoom',
      value: function onResetZoom() {
        this.setState({ zoom: 1 });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            enableZoom = _props.enableZoom,
            zoom = _props.zoom,
            childrenProps = _objectWithoutProperties(_props, ['enableZoom', 'zoom']);

        if (enableZoom) {
          return _react2.default.createElement(Component, _extends({}, childrenProps, {
            zoom: {
              value: this.state.zoom,
              onReset: this.onResetZoom,
              onZoomOut: this.onZoomOut,
              onZoomIn: this.onZoomIn
            }
          }));
        }

        return _react2.default.createElement(Component, childrenProps);
      }
    }]);

    return WithZoomChart;
  }(_react2.default.Component);

  WithZoomChart.defaultProps = {
    enableZoom: false
  };

  WithZoomChart.propTypes = _extends({}, Component.propTypes, {
    enableZoom: _propTypes2.default.bool.isRequired
  });

  return WithZoomChart;
}

exports.default = withZoom;